export default "__VITE_ASSET__2b176b3c__"